// src/disc/discScoring.js
//
// DISC PUANLAMA — TEK KAYNAK (2026-08-18)
//
// Ham sayım → yüzde çevrimi. Tablolar "DISC analizi envanter ŞABLON.xlsx"
// (30.04.2019) dosyasının formüllerinden makineyle çıkarılmıştır ve ÖLÇÜTTÜR.
// Ayrıntılı gerekçe ve karşılaştırma: ~/DISC/SomerenLabs_DISC_Puanlama_Referansi.md
//
// ─────────────────────────────────────────────────────────────────────────────
// UYARI — BURAYA ELLE SAYI YAZMA, BAŞKA DOSYAYA KOPYALAMA.
//
// 18.08.2026'ya kadar App.js ve ClassAnalysis.jsx kendi kopyalarını tutuyordu ve
// ikisi de şablondan farklıydı: kabaca yuvarlanmış, çapaları eksik tablolar.
// 56 hücrenin sadece 10'u tutuyordu. Sonuç: 14 profilin 9'unda bant dili (yüksek/
// orta/düşük), 2'sinde ise sıralama yanlıştı. Bir kişinin profili şablona göre
// YÜKSELİŞTE iken eski tabloya göre DÜŞÜŞTE görünüyordu.
// ─────────────────────────────────────────────────────────────────────────────

export const HARFLER = ["D", "I", "S", "C"];

// "En Çok" (M) sayımından uyarlanmış profil — şablon sütunları J / K,L,M,N
export const UYARLANMIS_TABLO = {
  D: { 0: 5, 1: 15, 2: 22.5, 3: 30, 4: 37.5, 5: 42.5, 6: 47.5, 7: 55, 8: 57.5, 9: 60, 10: 72.5, 11: 75, 12: 77.5, 13: 80, 14: 82.5, 15: 92.5, 16: 95, 20: 97.5 },
  I: { 0: 10, 1: 17.5, 2: 35, 3: 45, 4: 55, 5: 65, 6: 70, 7: 80, 8: 85, 9: 90, 10: 95, 17: 97.5 },
  S: { 0: 12.5, 1: 20, 2: 32.5, 3: 42.5, 4: 47.5, 5: 52.5, 6: 57.5, 7: 62.5, 8: 72.5, 9: 77.5, 10: 82.5, 11: 87.5, 12: 95, 19: 97.5 },
  C: { 0: 2.5, 1: 15, 2: 30, 3: 45, 4: 52.5, 5: 60, 6: 70, 7: 80, 8: 85, 9: 95, 15: 97.5 },
};

// "En Az" (L) sayımından doğal profil — şablon sütunları P / Q,R,S,T
// TERS PUANLAMA KASITLIDIR: az "en az" seçilen harf yüksek doğal skor alır.
export const DOGAL_TABLO = {
  D: { 0: 97.5, 1: 87.5, 2: 75, 3: 67.5, 4: 57.5, 5: 52.5, 6: 47.5, 7: 42.5, 8: 40, 9: 30, 10: 27.5, 11: 25, 12: 22.5, 13: 12.5, 14: 10, 15: 7.5, 16: 5, 21: 0 },
  I: { 0: 97.5, 1: 85, 2: 72.5, 3: 65, 4: 55, 5: 45, 6: 37.5, 7: 27.5, 8: 22.5, 9: 12.5, 10: 7.5, 11: 5, 19: 0 },
  S: { 0: 97.5, 1: 92.5, 2: 85, 3: 75, 4: 67.5, 5: 57.5, 6: 52.5, 7: 42.5, 8: 35, 9: 30, 10: 25, 11: 12.5, 12: 5, 13: 2.5, 19: 0 },
  C: { 0: 97.5, 1: 92.5, 2: 82.5, 3: 72.5, 4: 65, 5: 55, 6: 52.5, 7: 47.5, 8: 40, 9: 32.5, 10: 27.5, 11: 10, 12: 5, 13: 2.5, 16: 0 },
};

// Şablonda bazı ham skorların basılı satırı yoktur (ör. D uyarlanmışta 16'dan
// sonra 20'ye atlar). "dogrusal" = komşu çapalar arasında ara değer hesapla.
// Alternatif "ustBasamak" = fiziksel DISC grafiğindeki gibi bir üst basılı satıra
// yuvarla. Karar Ajlan'a aittir; mevcut 7 kayıtta hiç bu duruma düşülmedi.
// KARAR 2026-08-21 (Ajlan): "dogrusal" KALICI seçimdir, alternatif kapandı.
//
// Şablonda bazı ham skorların basılı satırı yok (D uyarlanmışta 17-18-19,
// I'da 11-16 gibi) — hepsi ölçeğin EN TEPESİNDE. Ölçüldü (200.000 benzetilmiş
// katılımcı): ara değere düşme oranı uyarlanmışta %0,13 · doğalda %0,04.
//
// Neden doğrusal: kâğıt grafikte ham 18 için basılı satır yoktur; dikkatli bir
// kişi 16 ile 20 arasına elle koyar — doğrusal ara değer tam olarak budur.
// "Üst basamağa yuvarla" 17/18/19'un üçünü de %97,5'e çıkarır ve abartır.
// Ayrıca motor sonucu tam sayıya yuvarladığı için rapora "95,36" değil "95"
// yazılır; ekranda şablonda olmayan bir sayı görünmez.
export const ARA_DEGER_KURALI = "dogrusal";

function cevir(tablo, ham) {
  const x = Math.max(0, Math.round(Number(ham) || 0));
  const capalar = Object.keys(tablo).map(Number).sort((a, b) => a - b);

  if (x <= capalar[0]) return tablo[capalar[0]];
  if (x >= capalar[capalar.length - 1]) return tablo[capalar[capalar.length - 1]];

  for (let i = 0; i < capalar.length - 1; i++) {
    const a = capalar[i];
    const b = capalar[i + 1];
    if (x === a) return tablo[a];
    if (x > a && x < b) {
      if (ARA_DEGER_KURALI === "ustBasamak") return tablo[b];
      const ya = tablo[a];
      const yb = tablo[b];
      return ya + ((yb - ya) * (x - a)) / (b - a);
    }
  }
  return tablo[capalar[capalar.length - 1]];
}

/** "En Çok" sayımlarından uyarlanmış profil yüzdeleri. */
export function uyarlanmisSkorlar(mostCounts = {}) {
  return Object.fromEntries(HARFLER.map((h) => [h, cevir(UYARLANMIS_TABLO[h], mostCounts[h])]));
}

/** "En Az" sayımlarından doğal profil yüzdeleri. */
export function dogalSkorlar(leastCounts = {}) {
  return Object.fromEntries(HARFLER.map((h) => [h, cevir(DOGAL_TABLO[h], leastCounts[h])]));
}

export { cevir };
